import React, { Fragment, useState, useEffect } from "react";

// Material-UI Core
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import InputBase from "@material-ui/core/InputBase";
import Collapse from "@material-ui/core/Collapse";

// Material-UI Icon
import SearchIcon from "@material-ui/icons/Search";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import PersonIcon from "@material-ui/icons/Person";

// Custom Style
import { transferGroupListStyle } from "../../styles/jss/components/transferList/transferGroupListStyle";

const not = (a, b) => {
  return a.filter((value) => b.indexOf(value) === -1);
};

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

function union(a, b) {
  return [...a, ...not(b, a)];
}

const useStyles = makeStyles((theme) => transferGroupListStyle(theme));

const TransferGroupList = (props) => {
  const classes = useStyles();
  const {
    typeSeq,
    internalOnly,
    listData,
    recipientType,
    reciptentChipAdd,
    reciptentChipRemove,

    leftToGroupRcpt,
    setLeftToGroupRcpt,
    rightToGroupRcpt,
    setRightToGroupRcpt,

    leftCcGroupRcpt,
    setLeftCcGroupRcpt,
    rightCcGroupRcpt,
    setRightCcGroupRcpt,

    leftResponsibleGroupRcpt,
    setLeftResponsibleGroupRcpt,
    rightResponsibleGroupRcpt,
    setRightResponsibleGroupRcpt,

    leftApproveGroupRcpt,
    setLeftApproveGroupRcpt,
    rightApproveGroupRcpt,
    setRightApproveGroupRcpt,

    leftConsultantGroupRcpt,
    setLeftConsultantGroupRcpt,
    rightConsultantGroupRcpt,
    setRightConsultantGroupRcpt,

    leftArchitectGroupRcpt,
    setLeftArchitectGroupRcpt,
    rightArchitectGroupRcpt,
    setRightArchitectGroupRcpt,
  } = props;

  const [open, setOpen] = useState([]);
  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);
  const [quickSearchKeyWord, setQuickSearchKeyWord] = useState("");

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggle = (value) => {
    // event.preventDefault()
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const saveRcptData = async (leftList, rightList) => {
    let tempRight = {};
    let tempLeft = {};

    tempRight[typeSeq] = rightList;
    tempLeft[typeSeq] = leftList;

    if (recipientType === "TO") {
      setRightToGroupRcpt({ ...rightToGroupRcpt, ...tempRight });
      setLeftToGroupRcpt({ ...leftToGroupRcpt, ...tempLeft });
    } else if (recipientType === "CC") {
      setRightCcGroupRcpt({ ...rightCcGroupRcpt, ...tempRight });
      setLeftCcGroupRcpt({ ...leftCcGroupRcpt, ...tempLeft });
    } else if (recipientType === "RESPONSIBLE") {
      setRightResponsibleGroupRcpt({
        ...rightResponsibleGroupRcpt,
        ...tempRight,
      });
      setLeftResponsibleGroupRcpt({ ...leftResponsibleGroupRcpt, ...tempLeft });
    } else if (recipientType === "APPROVE") {
      setRightApproveGroupRcpt({ ...rightApproveGroupRcpt, ...tempRight });
      setLeftApproveGroupRcpt({ ...leftApproveGroupRcpt, ...tempLeft });
    } else if (recipientType === "CONSULTANT") {
      setRightConsultantGroupRcpt({
        ...rightConsultantGroupRcpt,
        ...tempRight,
      });
      setLeftConsultantGroupRcpt({ ...leftConsultantGroupRcpt, ...tempLeft });
    } else if (recipientType === "ARCHITECT") {
      setRightArchitectGroupRcpt({ ...rightArchitectGroupRcpt, ...tempRight });
      setLeftArchitectGroupRcpt({ ...leftArchitectGroupRcpt, ...tempLeft });
    }
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));

    saveRcptData(not(left, leftChecked), right.concat(leftChecked)).then(() => {
      reciptentChipAdd("GROUP", leftChecked);
    });
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));

    saveRcptData(left.concat(rightChecked), not(right, rightChecked)).then(
      () => {
        reciptentChipRemove("GROUP", rightChecked);
      }
    );
  };

  const customList = (title, items) => (
    <Card>
      <CardHeader
        className={classes.cardHeader}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={
              numberOfChecked(items) === items.length && items.length !== 0
            }
            indeterminate={
              numberOfChecked(items) !== items.length &&
              numberOfChecked(items) !== 0
            }
            disabled={items.length === 0}
            inputProps={{ "aria-label": "all items selected" }}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${items.length} selected`}
      />

      <Divider />

      <List className={classes.list} dense component="div" role="list">
        {items.map((res) => {
          const labelId = `transfer-list-all-item-${res.seq}-label`;

          return (
            <div key={res.group_seq}>
              <ListItem
                key={res.group_seq}
                role="listitem"
                button
                // onClick={() => handleToggle(res)}
                // onClick={() => groupMenuHandleClick(res.group_seq, res)}
              >
                <ListItemIcon>
                  <Checkbox
                    onClick={() => handleToggle(res)}
                    checked={checked.indexOf(res) !== -1}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ "aria-labelledby": labelId }}
                  />
                </ListItemIcon>

                <ListItemText
                  id={labelId}
                  primary={res.group_name}
                  secondary={res.group_description}
                />

                {open.indexOf(res.group_seq) == -1 ? (
                  <ExpandMore
                    onClick={groupMenuHandleClick(res.group_seq, res)}
                  />
                ) : (
                  <ExpandLess
                    onClick={groupMenuHandleClick(res.group_seq, res)}
                  />
                )}
              </ListItem>

              <Collapse
                in={open.indexOf(res.group_seq) !== -1}
                timeout="auto"
                unmountOnExit
              >
                {res.group_members.map((member) => {
                  return (
                    <List
                      component="div"
                      disablePadding
                      key={member.member_seq}
                    >
                      <ListItem button className={classes.nested}>
                        <ListItemIcon>
                          <PersonIcon />
                        </ListItemIcon>
                        <ListItemText primary={member.member_fullname} />
                      </ListItem>
                    </List>
                  );
                })}
              </Collapse>
            </div>
          );
        })}
      </List>
    </Card>
  );

  const returnRecipientAfterAction = (rightUser, listOfUser) => {
    let rightArr = [];

    if (rightUser && rightUser.length > 0) {
      for (var i = 0; i < rightUser.length; i++) {
        rightArr.push(rightUser[i].group_seq);
      }
    }
    let internalList = listOfUser;
    internalList = listOfUser.filter(
      (obj) => !rightArr.includes(obj.group_seq)
    );
    return internalList;
  };

  const groupMenuHandleClick = (id) => () => {
    if (open.indexOf(id) !== -1) {
      setOpen([
        ...open.slice(0, open.indexOf(id)),
        ...open.slice(open.indexOf(id) + 1, open.length),
      ]);
    } else {
      setOpen([...open, id]);
    }
  };

  const quickSearch = (event) => {
    const keyWord = event.target.value !== null ? event.target.value : "";
    let filterResult = "";
    if (recipientType === "TO") {
      let internalList = returnRecipientAfterAction(
        rightToGroupRcpt[typeSeq],
        listData[typeSeq]
      );
      filterResult = internalList.filter((item) =>
        item.group_name.toLowerCase().includes(keyWord.toLowerCase())
      );
    } else if (recipientType === "CC") {
      let internalList = returnRecipientAfterAction(
        rightCcGroupRcpt[typeSeq],
        listData[typeSeq]
      );
      filterResult = internalList.filter((item) =>
        item.group_name.toLowerCase().includes(keyWord.toLowerCase())
      );
    }
    setLeft(filterResult);
  };

  useEffect(() => {
    if (recipientType === "TO") {
      let internalList = returnRecipientAfterAction(
        rightToGroupRcpt[typeSeq],
        listData[typeSeq]
      );
      leftToGroupRcpt === null || []
        ? setLeft(internalList)
        : setLeft(leftToGroupRcpt[typeSeq]);
      rightToGroupRcpt === null
        ? setRight([])
        : setRight(rightToGroupRcpt[typeSeq]);
    } else if (recipientType === "CC") {
      let internalList = returnRecipientAfterAction(
        rightCcGroupRcpt[typeSeq],
        listData[typeSeq]
      );
      leftCcGroupRcpt === null || []
        ? setLeft(internalList)
        : setLeft(leftCcGroupRcpt[typeSeq]);
      rightCcGroupRcpt === null
        ? setRight([])
        : setRight(rightCcGroupRcpt[typeSeq]);
    }
    // else if (recipientType === "RESPONSIBLE") {
    //   leftResponsibleGroupRcpt === null
    //     ? setLeft(listData)
    //     : setLeft(leftResponsibleGroupRcpt[typeSeq]);
    //   rightResponsibleGroupRcpt === null
    //     ? setRight([])
    //     : setRight(rightResponsibleGroupRcpt[typeSeq]);
    // } else if (recipientType === "APPROVE") {
    //   leftApproveGroupRcpt === null
    //     ? setLeft(listData)
    //     : setLeft(leftApproveGroupRcpt[typeSeq]);
    //   rightApproveGroupRcpt === null
    //     ? setRight([])
    //     : setRight(rightApproveGroupRcpt[typeSeq]);
    // } else if (recipientType === "CONSULTANT") {
    //   leftConsultantGroupRcpt === null
    //     ? setLeft(listData)
    //     : setLeft(leftConsultantGroupRcpt[typeSeq]);
    //   rightConsultantGroupRcpt === null
    //     ? setRight([])
    //     : setRight(rightConsultantGroupRcpt[typeSeq]);
    // } else if (recipientType === "ARCHITECT") {
    //   leftArchitectGroupRcpt === null
    //     ? setLeft(listData)
    //     : setLeft(leftArchitectGroupRcpt[typeSeq]);
    //   rightArchitectGroupRcpt === null
    //     ? setRight([])
    //     : setRight(rightArchitectGroupRcpt[typeSeq]);
    // }
    else {
      setLeft([]);
      setRight([]);
    }
  }, [listData]);

  return (
    // console.log("Recipient Type | Variable: recipientType (TransferGroupList.js)"),
    // console.log(recipientType),

    // console.log("User Group List | Variable: listData (TransferGroupList.js)"),
    // console.log(listData),

    // console.log("Checked Group | Variable: checked (TransferGroupList.js)"),
    // console.log(checked),

    // console.log("Left Checked User | Variable: leftChecked (TransferGroupList.js)"),
    // console.log(leftChecked),

    // console.log("Right Checked User | Variable: rightChecked (TransferGroupList.js)"),
    // console.log(rightChecked),

    // console.log("User List Left | Variable: left (TransferGroupList.js)"),
    // console.log(left),

    // console.log("User List Right | Variable: right (TransferGroupList.js)"),
    // console.log(right),

    // console.log("Left To Group Data | Variable: leftToGroupRcpt (TransferGroupList.js)"),
    // console.log(leftToGroupRcpt),

    // console.log("Right To Group Data | Variable: rightToGroupRcpt (TransferGroupList.js)"),
    // console.log(rightToGroupRcpt),

    // console.log("Left CC Group Data | Variable: leftCcGroupRcpt (TransferGroupList.js)"),
    // console.log(leftCcGroupRcpt),

    // console.log("Right CC Group Data | Variable: rightCcGroupRcpt (TransferGroupList.js)"),
    // console.log(rightCcGroupRcpt),

    console.log(
      "---------------------------------------------------------------------------------"
    ),
    (
      <Fragment>
        <div className={classes.searchBar}>
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>

            <InputBase
              onChange={quickSearch}
              placeholder="Quick Search"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ "aria-label": "search" }}
            />
          </div>
        </div>

        <Grid
          container
          spacing={2}
          justify="center"
          alignItems="center"
          className={classes.root}
        >
          <Grid item xs={5} md={5}>
            {customList("Choices", left)}
          </Grid>

          <Grid item xs={2} md={2}>
            <Grid container direction="column" alignItems="center">
              <Button
                variant="outlined"
                size="small"
                className={classes.button}
                onClick={handleCheckedRight}
                disabled={leftChecked.length === 0}
                aria-label="move selected right"
              >
                &gt;
              </Button>

              <Button
                variant="outlined"
                size="small"
                className={classes.button}
                onClick={handleCheckedLeft}
                disabled={rightChecked.length === 0}
                aria-label="move selected left"
              >
                &lt;
              </Button>
            </Grid>
          </Grid>

          <Grid item xs={5} md={5}>
            {customList("Chosen", right)}
          </Grid>
        </Grid>
      </Fragment>
    )
  );
};

export default TransferGroupList;
